import { route } from 'react-router-typesafe-routes/dom';

export const ROUTES = {
    STUDENT_DASHBOARD: route('dashboard'),
};

export const DASHBOARD_TABS = ['currently-studying', 'curriculum'] as const;
